module.exports = __webpack_public_path__ + "static/media/deez.9427e02c.svg";